import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-dark-950 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-dark-400 hover:text-white transition-colors mb-8"
        >
          <ArrowLeft size={20} />
          Zpět na hlavní stránku
        </Link>

        <h1 className="text-3xl font-bold text-white mb-8">Cookies</h1>

        <div className="prose prose-invert max-w-none space-y-6 text-dark-300">
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Co jsou cookies</h2>
            <p>
              Cookies jsou malé soubory ukládané do vašeho zařízení pro správné fungování
              aplikace a zlepšení uživatelské zkušenosti.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Používané cookies</h2>
            <ul className="list-disc list-inside space-y-2">
              <li><strong>Nezbytné</strong> – přihlášení a základní funkce</li>
              <li><strong>Analytické</strong> – anonymní statistiky návštěvnosti</li>
              <li><strong>Funkční</strong> – vaše preference a nastavení</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Správa cookies</h2>
            <p>
              Cookies můžete spravovat v nastavení prohlížeče. Odmítnutí cookies může
              omezit funkčnost aplikace.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Provozovatel</h2>
            <p>
              Nakladatelství Olomouc s.r.o.<br />
              Vítězství 229/7, 779 00 Olomouc<br />
              IČO: 64612023
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Kontakt</h2>
            <p>
              <a href="mailto:info@synapso.cz" className="text-primary-400 hover:text-primary-300">
                info@synapso.cz
              </a>
            </p>
          </section>

          <p className="text-dark-500 text-sm mt-8">
            Platné od 1. ledna 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
